
var $ = jQuery.noConflict();

$(function() {

  
  var timeSlider = $('.js-timeSlider');

  $(timeSlider).each(function() {

    // wrap timeline
    $('>*:first-child', this).wrap('<div class="js-timeSlider__wrap"></div>');

    // create left, right button and gradient div & add navigation
    var $nav = $('<div class="js-timeSlider__arrow js-timeSlider__arrow--prev"></div><div class="js-timeSlider__arrow js-timeSlider__arrow--next is-active"></div><div class="js-timeSlider__fade"></div>');
    $(this).append($nav);

    var timeline = $('.js-timeSlider__wrap > *:first-child', this),
    timelineChildren = $('>*',timeline),
    arrowPrev = $('.js-timeSlider__arrow--prev', this),
    arrowNext = $('.js-timeSlider__arrow--next', this);

    // add classnames to timeline children
    $(timelineChildren).each(function(index) {
      $(this).addClass('js-timeSlider__child');
    });

    $('.js-timeSlider__wrap').scroll(function() {

      var percentage = 100 * $(this).scrollLeft() / ($(timeline)[0].scrollWidth - $(this).width());

      if (percentage < 1.5) {
        
        if ( $(arrowPrev).hasClass('is-active') ) { $(arrowPrev).removeClass('is-active'); }
        if ( !$(arrowNext).hasClass('is-active') ) { $(arrowNext).addClass('is-active'); }
      }

      else if (percentage > 98) {
        if ( !$(arrowPrev).hasClass('is-active') ) { $(arrowPrev).addClass('is-active'); }
        if ( $(arrowNext).hasClass('is-active') ) { $(arrowNext).removeClass('is-active'); }
      }

      else {
        if ( !$(arrowPrev).hasClass('is-active') ) { $(arrowPrev).addClass('is-active'); }
        if ( !$(arrowNext).hasClass('is-active') ) { $(arrowNext).addClass('is-active'); }
      }

    });

    $(arrowNext).click(function() {
      var curr = $('.js-timeSlider__wrap').scrollLeft();
      $('.js-timeSlider__wrap').animate({scrollLeft: curr + 300}, 500);
    });

    $(arrowPrev).click(function() {
      var curr = $('.js-timeSlider__wrap').scrollLeft();
      $('.js-timeSlider__wrap').animate({scrollLeft: curr + -300}, 500);
    });
    
    // animateTimeline()
    // detectSwipeFn()
    

  });
 


});